import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';

import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { canConversationTransferToNumber } from 'components/conversation/utils/conversationTransfer';
import { transferToNumberActions } from 'components/shared/transferToNumberModal/actions/transferToNumberModal';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

const { transferToNumberModalOpen } = transferToNumberActions;

export const ConversationTransferToNumberButton = (): JSX.Element | null => {
  const dispatch = useAppDispatch();
  const { metaConversation, telephony, transferToNumberRequests } =
    useAppSelector((state) => ({
      metaConversation: state.conversation.metaConversation,
      telephony: state.telephony,
      transferToNumberRequests: state.transferToNumber.transferRequests,
    }));
  const canTransfer = canConversationTransferToNumber(
    metaConversation,
    telephony.staticTelephoneNumbersArray,
  );

  useCommandHandler({
    name: 'conversation:transferToNumber',
    actionFn: () => {
      if (canTransfer) {
        handleTransfer();
      }
    },
  });

  const handleTransfer = useCallback(() => {
    dispatch(transferToNumberModalOpen({ metaConversation }));

    ampli.conversationHeaderTransferToNumberButtonClicked();
  }, [dispatch, metaConversation]);

  const isTransferringToNumber = !!transferToNumberRequests.find(
    (request) =>
      request?.metaConversation?.conversation?.id ==
      metaConversation.conversation.id,
  );

  const tooltipContent = (
    <CommandKeybindingsTooltipContent commandName="conversation:transferToNumber">
      Transfer to number
    </CommandKeybindingsTooltipContent>
  );

  return canTransfer ? (
    <Tooltip content={tooltipContent}>
      <IconButton
        variant="tertiary"
        icon="arrow-right"
        isLoading={isTransferringToNumber}
        onClick={() => handleTransfer()}
      />
    </Tooltip>
  ) : null;
};
